import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/edit.svg";
var EditOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  EditOutline_default as default
};
